import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function RevertIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-revert-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.22 31.7c-.16-.32-.32-.63-.47-.95-.8-1.77-1.98-3.24-3.47-4.49-1.39-1.17-2.97-1.95-4.69-2.47-.63-.19-1.29-.24-1.94-.34-.36-.06-.72-.08-1.07-.13-.34-.05-.44.1-.44.43.01 1.29.04 2.59-.01 3.88-.05 1.34-1.11 2.22-2.35 2.13-.58-.04-1.05-.39-1.51-.71l-8.38-5.59c-1.31-.87-2.62-1.73-3.92-2.61-1.42-.96-1.22-2.91.17-3.75 1.72-1.04 3.35-2.23 5.02-3.35 1.96-1.31 3.93-2.6 5.9-3.9.66-.43 1.29-.9 1.97-1.29 1.14-.66 2.68.01 3 1.3.07.29.11.59.11.89.01 1.19.01 2.37 0 3.56 0 .3.05.45.42.46 1.2.01 2.36.26 3.5.61 2.27.69 4.15 1.97 5.71 3.71 1.19 1.33 2.07 2.87 2.61 4.6.52 1.67.72 3.37.55 5.09-.1.98-.35 1.94-.54 2.91-.05 0-.11 0-.17.01z"
  })));
}